import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button/Button';

function BatchSearchProgressModalFooter(props) {
  const { cancelSearch } = props;

  return (
    <div className="batch-search-modal__footer">
      <Button
        buttonConfig={{
          type: 'link',
          size: 'sm',
          label: 'Cancel',
          e2eName: 'batch-modal-search-cancel',
        }}
        iconConfig={{ name: 'delete', size: 'sm' }}
        onClick={cancelSearch}
      />
    </div>
  );
}

BatchSearchProgressModalFooter.propTypes = {
  cancelSearch: PropTypes.func.isRequired,
};

export default BatchSearchProgressModalFooter;
